import config from "../config"
const base_url = config.base_url
export const deleteCustomer = (username) => {
    
    return (fetch(base_url+'admin/customer/delete',{
        method: 'POST',
        mode: 'cors',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-type': 'application/x-www-form-urlencoded',
            'credentials':'include'
        },
        credentials:'include',
        body: `username=${username}`
        }))

}